export enum ResultadoDiagnosticoEnum {
    N = 0, // Negative
    P = 1, // Positive
    R = 2, // Reconfirm
    A = 3, // Anestro
    C = 4, // Cycling
    S = 5  // Synchronizing
}
